/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { EDocDetailsDto } from './e-docs.dto';
import { EDocDetailsMapper } from './e-docs.mapper';

@Injectable()
export class EDocRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(documentId: ID): Observable<EDocDetailsDto> {
    return this.httpGet(`${this.bp}/edocs/${documentId}`, EDocDetailsMapper);
  }
}
